import { kebabCase, titleCase } from 'change-case'
import React, { useEffect, useState } from 'react'
import { Theme, ZIndex } from '@opallabs/gem'
import { ThemeProvider } from '@opallabs/hooks'
import { ActionsMenu, Icon } from '@opallabs/lapidary'
import * as styles from './styles'

type Display = {
  systemName: string
  device: string
  mode: string
}

type ContentCardDisplayPickerProps = {
  displays: Array<Display>
  onSelect: (display: Display) => void
  initialDisplay: Display
  servicePostType: string
  theme: Theme
}

export const ContentCardDisplayPicker: React.FC<
  ContentCardDisplayPickerProps
> = ({ displays, onSelect, initialDisplay, servicePostType, theme }) => {
  const [currentServicePostType, setCurrentServicePostType] =
    useState(servicePostType)
  const [selectedDisplay, setSelecteDisplay] = useState(initialDisplay)

  useEffect(() => {
    if (servicePostType !== currentServicePostType) {
      setSelecteDisplay(initialDisplay)
      setCurrentServicePostType(servicePostType)
    }
  }, [servicePostType, currentServicePostType, initialDisplay])

  return (
    <ThemeProvider theme={theme}>
      <ActionsMenu.Base
        align="end"
        className="lapidary-content-card-display-picker"
        contentStyles={{ minInlineSize: 210 }}
        displayMenuIndicator={true}
        glyph={selectedDisplay.device}
        glyphColor="Secondary"
        showArrow={true}
        tooltipContent={titleCase(selectedDisplay.systemName)}
        variant="ghost"
        zIndex={ZIndex.Shroud.Popover}
      >
        {displays.map((display) => (
          <ActionsMenu.Item
            key={display.systemName}
            className={`display-option-${kebabCase(display.systemName)}`}
            aria-selected={selectedDisplay.systemName === display.systemName}
            css={styles.selectedItemStyles(theme)}
            onSelect={() => {
              setSelecteDisplay(display)
              onSelect(display)
            }}
          >
            <span css={styles.itemContent}>
              <Icon glyph={display.device} useHypernova={true} />
              {titleCase(display.systemName)}
            </span>
          </ActionsMenu.Item>
        ))}
      </ActionsMenu.Base>
    </ThemeProvider>
  )
}
